import { lazy } from "react";
import Loadable from "../Loadable";
import BaseLayout from "components/layouts/baseLayout";
import PublicGuard from "../PublicGuard";

//pages
const Home = Loadable(lazy(() => import("pages/home")));
const Login = Loadable(lazy(() => import("pages/auth/Login")));

const PublicRoutes = {
  element: <BaseLayout />,
  children: [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "login",
      element: (
        <PublicGuard>
          <Login />
        </PublicGuard>
      ),
    },
  ],
};

export default PublicRoutes;
